<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      router-view
</template>

<script>
export default {
  name: 'groups-component'
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
}

.row, .col, .container-fluid {
  margin: 0;
  padding: 0;
}
</style>
